// extracted by mini-css-extract-plugin
export default {"analysis":"Analysis_analysis__R15vq"};